<template>
    <el-drawer
      v-model="is_show_drawer"
      size="90%"
      class="tag-product-drawer"
      :destroy-on-close="true"
    >
      <header class="head" :data-tag-type="tag_type" :data-tag-content-id="tag_content_id">
        <i @click="back"><svg-icon :name="back_icon" /></i>
        <h2>{{ is_review_products ? 'Review added products' : `${page_type === 'url' ? 'Add Products via URL' : page_type === 'catalog' ? 'Add Products via Catalog' : 'Add from Curated Products'}`  }}</h2>
        <el-button v-if="is_review_products" type="primary" :disabled="tagged_products.filter(item => item.is_checked).length === 0" @click="checkRemoveProducts()">Remove selected</el-button>
        <el-button v-if="!is_review_products && page_type !== 'url'" type="primary" :disabled="tagged_products.length === 0" @click="is_review_products = true">Add {{ tagged_products.length === 0 ? '' : ` (${tagged_count})` }} and review</el-button>
        <el-button v-else type="primary" :disabled="tagged_products.length === 0" @click="taggedProducts">Done</el-button>
      </header>

      <div class="content-box type-url" v-if="page_type === 'url'" v-loading="is_update_data">
        <div class="input-box">
          <div class="top-col">
            <header>
              <!-- <el-image :src="storefront.brand_logo" fit="contain" /> -->
              <h2>{{ storefront.merchant_display_name }}</h2>
              <p class="link"><a :href="storefront.main_domain" target="_blank">{{ storefront.main_domain }} <svg-icon name="go-out" /></a></p>
            </header>
            <div class="input-url">
              <label>Paste the product link below</label>
              <el-form-item>
                <el-input placeholder="Paste product URL (https://....}" v-model="url" size="large" @keyup.enter="onSubmitUrl" />
                <el-button type="primary" :disabled="!is_correct_url" size="large" @click="onSubmitUrl"><svg-icon name="arrow-next" /></el-button>
              </el-form-item>
              <p v-if="tagged_products.length !== 0">
                Paste another URL to add another product
              </p>
            </div>
          </div>
          
          <div class="tip-box" v-if="tagged_products.length === 0">
            <p>
              <svg-icon name="tip" />
              Make sure you're copying a direct link to the product you'd like to add to your storefront. See example page below.
            </p>
            <img v-if="projectName === 'sephora'" src="@/assets/images/url-sephora.png" />
            <img v-else src="@/assets/images/url.png" />
          </div>

          <div v-else class="review-products-wrap">
            <header>
              <h2>Review added products</h2>
              <el-button type="secondary" :disabled="tagged_products.filter(item => item.is_checked).length === 0" @click="checkRemoveProducts()">Remove selected</el-button>
            </header>
            <review-products :products="tagged_products" @remove-product="checkRemoveProducts" :add_type="tag_type" />
          </div>
        </div>
      </div>
      <div class="list-box" v-loading="is_update_data" v-else>
        <header class="info-head">
          <div class="info">
            <el-image :src="storefront.brand_logo" fit="contain" />
            <h2>{{ storefront.merchant_display_name }}</h2>
          </div>
          <template v-if="!is_review_products">
            <div class="filter-wrap" v-if="(!is_loading && products.length > 0) || is_searching" :class="{ 'has-brands': page_type === 'catalog' && brands.length > 1 }">
              <el-input v-model="params.keyword" placeholder="Search product" @keyup.enter="getProducts(false, true)" size="large">
                <template #suffix>
                  <svg-icon name="search" />
                </template>
              </el-input>
              <el-button @click="is_show_filter = true" plain size="large"><svg-icon name="filter" /> Sort & Filter</el-button>
              <el-button v-if="page_type === 'catalog' && brands.length > 1" @click="is_show_brands = true" plain size="large"><svg-icon name="filter" /> Brands</el-button>
            </div>
            <div class="tags" v-if="is_searching && (searched.stort || searched.price || params.keyword || searched_brands.length !== 0)">
              <el-tag v-if="searched_brands.length !== 0" v-for="brand in searched_brands" :key="brand.id" @click="clearSearch('brand', brand)" :disable-transitions="true">
                Brand: <span v-html="brand.name"></span> <svg-icon name="close" />
              </el-tag>
              <el-tag v-if="params.keyword" @click="clearSearch('keyword')" :disable-transitions="true">
                Search: {{ params.keyword }} <svg-icon name="close" />
              </el-tag>
              <el-tag @click="clearSearch('stort')" v-if="searched.stort !== ''" :disable-transitions="true">
                {{ searched.stort }} <svg-icon name="close" />
              </el-tag>
              <el-tag @click="clearSearch('price')" v-if="searched.price" :disable-transitions="true">
                {{ searched.price }} <svg-icon name="close" />
              </el-tag>
            </div>
          </template>
        </header>

        <!-- <h2 class="list-title" v-if="!is_loading">Best sellers</h2> -->
        <template v-if="!is_review_products">
          <div class="product-list" v-loading="is_loading">
            <product-tag-item
              v-for="(product, index) in products"
              :key="index"
              :product="product"
              :is_tag="true"
              :is_not_show_is_tagged="tag_type === 'new-post'"
              :is_tagged="tagged_ids.includes(product.id)"
              :is_enable_color_size_picker="storefront.is_enable_color_size_picker"
              :add_type="tag_type"
              :merchant_account_id="storefront.id"
              @tag="tagProduct(product)"
            />
          </div>
          <div class="load-more" v-if="!is_loading && !is_end" v-loading="is_loading_more">
            <el-button v-if="!is_loading_more" type="primary" size="large" @click="getProducts(true)">Load more</el-button>
          </div>
          <div class="no-product" v-if="!is_loading && !is_loading_more && is_end">
            <div v-if="products.length === 0 && !is_searching">
              <svg-icon name="bag" />
              <h3>Your storefront currently is empty</h3>
              <p>Please add some products to your storefront and try again later.</p>
            </div>
            <p v-if="products.length === 0 && is_searching">
              No products found
            </p>
            <p v-else>
              No more products
            </p>
          </div>
        </template>

        <review-products v-else :products="tagged_products" @remove-product="checkRemoveProducts" :add_type="tag_type" />
      </div>
    </el-drawer>

    <el-dialog v-model="is_show_filter" :destroy-on-close="true" class="tag-filter-dialog" title="Sort & Filter" width="420px">
      <div class="filter-box">
        <div class="sort">
          <h3>Sort by</h3>
          <el-radio-group v-model="params.sort_by">
            <el-radio label="price_low_to_high" value="asc" @click.native.prevent="changeRadio('asc')">Price: Low to High</el-radio>
            <el-radio label="price_high_to_low" value="desc" @click.native.prevent="changeRadio('desc')">Price: High to Low</el-radio>
          </el-radio-group>
        </div>
        <div class="filter">
          <h3>Price</h3>
          <div class="inputs">
            <el-select v-model="params.price_range.currency" placeholder="Select">
              <el-option
                v-for="item in currencys"
                :key="item"
                :label="item"
                @click="params.price_range.currency = item"
              />
            </el-select>
            <el-input-number v-model="params.price_range.min" :min="0" :max="params.price_range.max ? params.price_range.max : 999999999" :step="1" :controls="false" placeholder="Min" />
            <span> to </span>
            <el-input-number v-model="params.price_range.max" :min="params.price_range.min" :step="1" :controls="false" placeholder="Max" />
          </div>
        </div>
      </div>
      <div class="btn-box">
        <el-button type="text" @click="is_show_filter = false" size="large">Cancel</el-button>
        <el-button type="primary" @click="getProducts(false, true)" size="large">Apply</el-button>
      </div>
    </el-dialog>
    <el-dialog v-model="is_show_brands" :destroy-on-close="true" class="tag-filter-dialog" title="Brands" width="460px">
      <div class="brands-box">
        <div class="search-box">
          <el-input 
            v-model="brandSearchKeyword" 
            placeholder="Search brands" 
            size="large"
            clearable
          >
            <template #prefix>
              <svg-icon name="search" />
            </template>
          </el-input>
        </div>
        <div class="filter-letters">
          <el-button 
            :class="{ active: selected_letter === 'ALL' }" 
            @click="filterBrandsByLetter('ALL')"
          >ALL</el-button>
          <template v-for="letter in 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')" :key="letter">
            <el-button 
              :class="{ active: selected_letter === letter }" 
              @click="filterBrandsByLetter(letter)"
              v-if="hasBrandsStartingWith(letter)"
            >{{ letter }}</el-button>
          </template>
          <template v-for="num in '1234567890'.split('')" :key="num">
            <el-button 
              :class="{ active: selected_letter === num }" 
              @click="filterBrandsByLetter(num)"
              v-if="hasBrandsStartingWith(num)"
            >{{ num }}</el-button>
          </template>
        </div>
        <div class="brands-list">
          <el-checkbox-group v-model="selected_brands">
            <el-checkbox 
              v-for="brand in filteredBrands" 
              :key="brand.id" 
              :label="brand"
            >
              <div class="brand-item">
                <span>{{ brand.name }}</span>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="btn-box">
        <el-button type="text" @click="selectBrands(true)" size="large">Reset</el-button>
        <el-button type="primary" @click="selectBrands()" size="large">Apply</el-button>
      </div>
    </el-dialog>
    <el-dialog class="alert-modal" v-model="is_show_alert_modal" width="380px">
        <div class="content">
            <i><svg-icon name="alert" /></i>
            <!-- <h2>URL does not match Brand selected. Please try again.</h2> -->
            <h2>Product URL is currently not in product feed. Please try again later.</h2>
        </div>
        <footer class="one-btn">
            <el-button type="primary" @click="is_show_alert_modal = false">Try again</el-button>
        </footer>
    </el-dialog>
    <el-dialog class="alert-modal alert-modal-2" v-model="is_show_alert_modal_2" width="380px">
      <div class="content">
        <h2>Sorry we couldn’t match this link to our product catalog.</h2>
        <p>Please check the link and try again.</p>
      </div>
      <footer>
        <el-button type="text" @click="is_show_alert_modal_2 = false">Cancel</el-button>
        <el-button type="primary" @click="is_show_alert_modal_2 = false; url = '';">Try again</el-button>
      </footer>
    </el-dialog>
    <el-dialog class="alert-modal alert-modal-2" v-model="is_show_alert_modal_3" width="380px">
      <div class="content">
        <h2>Unsaved changes</h2>
        <p>{{ tagged_products.length }} of product{{ tagged_products.length > 1 ? 's' : '' }} changes had changes not saved, do you want to save all the changes before quitting editing?</p>
      </div>
      <footer>
        <el-button type="text" @click="closeCallback(false)">Cancel</el-button>
        <el-button type="primary" @click="closeCallback(true)">Confirm and save</el-button>
      </footer>
    </el-dialog>
    <el-dialog class="alert-modal alert-modal-2" v-model="is_show_remove_product_modal" width="380px">
      <div class="content" v-if="remove_products.length === 1">
        <h2>Remove product?</h2>
        <p>This product will not be added to creators' storefronts.</p>
      </div>
      <div class="content" v-else>
        <h2>Remove these products?</h2>
        <p>The {{ remove_products.length }} of products will not add to creator’s storefront</p>
      </div>
      <footer>
        <el-button type="text" @click="is_show_remove_product_modal = false">Back</el-button>
        <el-button type="primary" @click="is_show_remove_product_modal = false; removeTaggedProducts()">Confirm</el-button>
      </footer>
    </el-dialog>
    <div class="tag-product-click-bg" @click="back" v-if="is_show_drawer"></div>
    <select-product-variants
      :add_type="props.tag_type"
      :tagged_products="tagged_products"
      @remove-product="checkRemoveProducts"
      ref="tag_product_drawer_el"
    />
    <edit-product-popup
      :storefront="props.storefront"
      :product="new_product"
      :product_url="url"
      @selected="selected"
      ref="edit_product_el"
    />
    <!-- :content_id="props.tag_content_id"
    :merchant_account_id="props.storefront?.id" -->
</template>
  
<script setup>
  import { ref, getCurrentInstance, computed, onMounted } from 'vue';
  // import ProductOtherColorPopup from './ProductOtherColorPopup.vue';
  import EditProductPopup from './EditProductPopup.vue';
  import ProductTagItem from './ProductTagItem.vue';
  import ReviewProducts from './ReviewProducts.vue';
  import SelectProductVariants from './SelectProductVariants.vue';
  import initProductData from './initData';
  import { ElDrawer, ElButton, ElImage, ElFormItem, ElInput, ElTag, ElDialog, ElRadioGroup, ElRadio, ElSelect, ElOption, ElInputNumber, ElCheckboxGroup, ElCheckbox } from 'element-plus';
  
  const app = getCurrentInstance();
  // const store = app.appContext.config.globalProperties.$store;
  const ajax = app.appContext.config.globalProperties.$ajax;
  const event = app.appContext.config.globalProperties.EventBus;
  const projectName = ref(app.appContext.config.globalProperties.$ProjectName);

  const emit = defineEmits(['tagged']);
  const is_show_drawer = ref(false);
  const productData = ref({});
  const tag_product_drawer_el = ref(null);

  const props = defineProps({
    storefront: {
      type: Object,
      default: () => ({})
    },
    tag_type: {
      type: String,
      default: ''
    },
    tag_content_id: {
      type: Number,
      default: 0
    },
    tagged_ids: {
      type: Array,
      default: () => []
    },
  });

  const page_type = ref('url'); // catalog, url, storefront
  const url = ref('');
  const is_update_data = ref(false);
  const is_show_alert_modal = ref(false);
  const is_show_alert_modal_2 = ref(false);
  const is_show_alert_modal_3 = ref(false);
  const is_review_products = ref(false);
  const new_product = ref(null);
  const tagged_products = ref([]);
  const products = ref([]);
  const remove_products = ref([]);
  const is_show_remove_product_modal = ref(false);
  const page = ref(1);
  const params = ref({
    keyword: '',
    sort_by: '',
    price_range: {
      min: null,
      max: null,
      currency: 'USD'
    },
  });
  const searched = ref({
    stort: '',
    price: '',
  });
  const currencys = ref([
    'USD',
    'CAD',
    'GBP',
    'EUR',
    'AUD',
  ]);
  const is_show_filter = ref(false);
  const is_show_brands = ref(false);
  const is_end = ref(false);
  const is_loading = ref(false);
  const is_loading_more = ref(false);
  const is_searching = ref(false);
  // const other_color_el = ref(null);
  const edit_product_el = ref(null);
  const brands = ref([]);
  const selected_brands = ref([]);
  const selected_letter = ref('ALL');
  const searched_brands = ref([]);
  const brandSearchKeyword = ref('');

  const back_icon = computed(() => {
    return is_review_products.value ? 'arrow-prev' : 'close';
  });

  const tagged_count = computed(() => {
    let count = 0;
    
    tagged_products.value.forEach(product => {
      if (product.total_color_size_map && product.total_color_size_map.some(item => item.is_selected)) {
        // if product has variants and some are selected, count selected variants
        count += product.total_color_size_map.filter(item => item.is_selected).length;
      } else {
        // Otherwise count by product quantity
        count += 1;
      }
    });
    
    return count;
  });

  const is_correct_url = computed(() => {
    let inputUrl = url.value.trim()
    if (!inputUrl) {
      return false
    }

    // if URL does not start with http:// or https://, add http://
    if (!/^https?:\/\//i.test(inputUrl)) {
      inputUrl = 'https://' + inputUrl
    }

    try {
      // check if the URL is valid
      const parsedUrl = new URL(inputUrl);
      // remove www. from the hostname

      const inputDomain = parsedUrl.hostname.replace(/^www\./i, '');
      
      const mainDomain = props.storefront.main_domain
        .replace(/^https?:\/\//i, '')
        .replace(/^www\./i, '')
        .replace(/\/+$/, '');

      // check if all_allow_tag_domains is available and not empty
      let allowDomains = props.storefront.all_allow_tag_domains;
      // console.log('allowDomains', allowDomains);
      // let allowDomains = ['https://www.example1.com', 'https://example2.com', 'example3.com']; // Example allowed domains

      if (allowDomains && allowDomains.length > 0) {
        // Ensure mainDomain is included in allowDomains to avoid missing it
        const normalizedAllowDomains = allowDomains.map(domain => 
          domain
            .replace(/^https?:\/\//i, '')
            .replace(/^www\./i, '')
            .replace(/\/+$/, '')
        );
        if (!normalizedAllowDomains.includes(mainDomain)) {
          normalizedAllowDomains.push(mainDomain);
        }
        return normalizedAllowDomains.includes(inputDomain);
      }

      // fallback to mainDomain check
      return inputDomain === mainDomain;
    } catch (error) {
      // URL is not valid
      return false
    }
  });

  const checkRemoveProducts = (product = null) => {
    remove_products.value = [];
    // console.log('checkRemoveProducts', product);

    if (product) {
      remove_products.value.push(product.id);
    } else {
      tagged_products.value.forEach(item => {
        if (item.is_checked) {
          remove_products.value.push(item.id);
        }
      });
    }
    // console.log('checkdRemoveProducts', remove_products.value);

    is_show_remove_product_modal.value = true;
  }

  const removeTaggedProducts = () => {
    tag_product_drawer_el.value.close();

    tagged_products.value = tagged_products.value.filter(product => !remove_products.value.includes(product.id));
    products.value.forEach(product => {
      if (remove_products.value.includes(product.id)) {
        product.is_tagged = false;

        // reset selected variants
        product.total_color_size_map.forEach(item => {
          item.is_selected = false;
          item.is_checked = false;
        });
      }
    });
    remove_products.value = [];
  }

  const selected = (item) => {
 
    if (item) {
      // tagged_products.value.push(product);
      const product = initProductData(item);
      product.is_tag_from_url = true;
      product.website_url = url.value;
      // match_products.forEach(p => {
      //   product.unique_color_list.push(p.color);

      //   product.total_color_size_map.push({
      //     product_id: p.id,
      //     thumbnail: p.image,
      //     swatch_image_url: p.image,
      //     color: p.color,
      //     size: '',
      //     is_selected: false,
      //     is_checked: false,
      //     availability: 0,
      //     is_added_in_collection: false,
      //     is_added_in_post: false,
      //     is_added_in_storefront: false
      //   });
      // });

      // product.unique_color_count = match_products.length;
      // console.log('selected product', product);

      // check if the product has other colors
      productData.value = product;
      url.value = '';

      setTimeout(() => {
        // other_color_el.value.open();
        event.emit('select-variant', productData.value);
        is_update_data.value = false;

      }, 10);
    } 
    
    else {
      // fetchProduct();
      url.value = '';
    }
  }
  
  const onSubmitUrl = () => {
    if (is_correct_url.value) {
      is_update_data.value = true;

      if (projectName.value === 'sephora') {
        getSephoraProductFromUrl();
      } else {
        getProductFromUrl();
      }
    }
  }


  const getProductFromUrl = () => {
    const obj = {
      product_url: url.value,
      merchant_account_id: props.storefront.id
    }

    ajax.post('/storefront-curation/product/get-product-with-other-colors', obj).then((response) => {
      const res = response.data.data;
      const match_products = response.data.data.match_products;

      

      // console.log('getProductFromUrl', res, match_products);

      if (res.is_valid_co_op_brand_for_the_merchant === false) {
        is_show_alert_modal.value = true;
        url.value = '';
        is_update_data.value = false;
      }

      else if (res.match_products.length === 0) {
        fetchProduct();
      }

      // else if (!product.total_color_size_map || product.total_color_size_map.length === 0 || match_products.length === 0) {
      //   // if no other colors, directly add the product
      //   tagged_products.value.push(product);
      //   url.value = '';
      //   is_update_data.value = false;
      // }
      else {
        const product = initProductData(res.best_match_product);
        product.is_tag_from_url = true;
        product.website_url = url.value;
        
        const isColorProducts = match_products.every(p => p.color && p.color !== null && p.color.trim() !== '');

        // check if the product has other colors        
        if (isColorProducts) {
          match_products.forEach(p => {
            product.unique_color_list.push(p.color);

            product.total_color_size_map.push({
              product_id: p.id,
              thumbnail: p.image,
              swatch_image_url: p.image,
              color: p.color,
              size: '',
              is_selected: false,
              is_checked: false,
              availability: 0,
              is_added_in_collection: false,
              is_added_in_post: false,
              is_added_in_storefront: false
            });
          });

          product.unique_color_count = match_products.length;
        }


        // console.log('isColorProducts', isColorProducts, product);
        // check if the product has other colors
        productData.value = product;

        setTimeout(() => {
          // other_color_el.value.open();
          event.emit('select-variant', productData.value);
          is_update_data.value = false;

        }, 10);
      }


    }).catch((error) => {
      is_show_alert_modal.value = true;
      is_update_data.value = false;

    });
  }

  const getSephoraProductFromUrl = () => {
    const obj = {
      product_url: url.value,
    }

    if (props.tag_type === 'post') {
      obj.anchor_post_id = props.tag_content_id;
    } else if (props.tag_type === 'collection') {
      obj.anchor_collection_id = props.tag_content_id;
    }

    ajax.post('/storefront-curation/product/get-sephora-product-from-url', obj).then((response) => {
      const res = response.data.data;

      if (!res || res.length === 0) {
        is_show_alert_modal_2.value = true;

        setTimeout(() => {
          is_update_data.value = false;
        }, 10);
      } else {
        const fobj = {
          params: {
            product_id: res.id,
            merchant_account_id: props.storefront.id
          }
        };

        if (props.tag_type === 'collection') {
          fobj.params.anchor_collection_id = props.tag_content_id;
        } else if (props.tag_type === 'post') {
          fobj.params.anchor_post_id = props.tag_content_id;
        }

        ajax.get('/storefront-curation/product/get-sephora-product-detail', fobj).then((res2) => {
          // res2.data.data.total_color_size_map;
          // if (!res2.data.data.total_color_size_map || res2.data.data.total_color_size_map.length === 0) {
          //   const obj = {
          //     match_products: [res]
          //   }
            
          //   productData.value = obj;
            
          //   setTimeout(() => {
          //     // other_color_el.value.open();
          //     event.emit('select-variant', productData.value);
          //     is_update_data.value = false;

          //   }, 10);
          // } else {
          //   productData.value = res2.data.data;
          //   res2.data.data.is_tag_from_url = true;
          //   event.emit('select-variant', res2.data.data);
          // }
          const product = initProductData(res2.data.data);

          product.is_tag_from_url = true;
          product.website_url = url.value;
          productData.value = product;
          event.emit('select-variant', product);

          setTimeout(() => {
            is_update_data.value = false;
          }, 10);
        });
        
      }
    }).catch((error) => {
      is_update_data.value = false;

    });
  }


  const fetchProduct = () => {
    is_update_data.value = true;

    const obj = {
      url: url.value,
      merchant_account_id: props.storefront.id
    }

    ajax.post('/storefront-curation/product/fetch', obj).then((response) => {
      const res = response.data.data;
      // console.log('fetchProduct', response.data, res);
      new_product.value = res;
      
      setTimeout(() => {
        edit_product_el.value.open();
      }, 10);
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      is_update_data.value = false;
    });
  }



  const changeRadio = (val) => {
    params.value.sort_by = params.value.sort_by === val ? '' : val;
  }

  const back = () => {
    if (is_review_products.value) {
      is_review_products.value = false;
      return;
    }

    if (tagged_products.value.length !== 0) {
      is_show_alert_modal_3.value = true;
    } else {
      is_show_drawer.value = false;
    }
  }

  const closeCallback = (is_add_product) => {
    is_show_alert_modal_3.value = false;

    if (is_add_product) {
      is_show_drawer.value = false;
      taggedProducts();
    } else {
      is_show_drawer.value = false;
    }
  }

  const tagProduct = (product) => {
    product.is_tagged = !product.is_tagged;

    if (product.is_tagged) {
      tagged_products.value.push(product);
    } else {
      const index = tagged_products.value.findIndex((item) => item.id === product.id);
      tagged_products.value.splice(index, 1);
    }
    
  }

  // const updateTagProduct = (product) => {
  //   console.log('updateTagProduct', product.total_color_size_map);
  // }

  const taggedProducts = () => {
   
    emit('tagged', tagged_products.value);
  }

  const clearSearch = (type, item = null) => {
    if (type === 'stort') {
      params.value.sort_by = '';
    } 
    
    else if (type === 'price') {
      params.value.price_range.min = null;
      params.value.price_range.max = null;
      params.value.price_range.currency = 'USD';
    }

    else if (type === 'keyword') {
      params.value.keyword = '';
    }

    else if (type === 'brand') {
      selected_brands.value = selected_brands.value.filter((brand) => brand.id !== item.id);
    }

    getProducts(false, true);
  }

  const getProducts = (is_next = false, is_search = false) => {
    if (is_next) {
      page.value ++;
      is_loading_more.value = true;
    } else {
      is_loading.value = true;
      products.value = [];
      page.value = 1;
      is_searching.value = false;

      if (!is_search) {
        params.value = {
          keyword: '',
          sort_by: '',
          price_range: {
            min: null,
            max: null,
            currency: 'USD'
          },
        };

        searched.value = {
          stort: '',
          price: '',
        };

        selected_brands.value = [];
        searched_brands.value = [];
        brandSearchKeyword.value = '';
        selected_letter.value = 'ALL';
      }
    }

    let api_url = page_type.value === 'catalog' ? '/storefront-curation/product/search' : '/storefront-curation/get-curation-product-item-list';
    let api = `${api_url}?merchant_account_id=${props.storefront.id}&page=${page.value}`;
    is_searching.value = params.value.keyword || params.value.sort_by || params.value.price_range.min || params.value.price_range.max || selected_brands.value.length !== 0;

    //if (is_search) {
      is_show_filter.value = false;
      is_show_brands.value = false;
      searched_brands.value = selected_brands.value;

      if (props.tag_type === 'collection') {
        api += `&curation_collection_id=${props.tag_content_id}`;
      } else if (props.tag_type === 'post') {
        api += `&curation_post_id=${props.tag_content_id}`;
      }

      if (searched_brands.value.length > 0) {
        searched_brands.value.forEach((brand) => {
          api += `&brand_ids[]=${brand.id}`;
        });
      }

      if (params.value.keyword) {
        api += `&text=${params.value.keyword}`;
      }

      if (params.value.sort_by) {
        api += `&order_by=price&direction=${params.value.sort_by}`;
        searched.value.stort = params.value.sort_by === 'asc' ? 'Price: Low to High' : 'Price: High to Low';
      } else {
        searched.value.stort = '';
      }
      let handlmaxValue = JSON.parse(JSON.stringify(params.value.price_range.max));
      let handlShowmaxValue = JSON.parse(JSON.stringify(params.value.price_range.max));
      if (params.value.price_range.min || params.value.price_range.max) {
        if (!params.value.price_range.min ) params.value.price_range.min = 0;
        if (!params.value.price_range.max) {
          handlmaxValue= 999999999;
          handlShowmaxValue = '';
        }

        api += `&price_from=${params.value.price_range.min}&price_to=${handlmaxValue}`;
        const c = params.value.price_range.currency === 'USD' ? '' : params.value.price_range.currency;
        searched.value.price = `Price from ${c} ${params.value.price_range.min} ~ ${c} ${handlShowmaxValue}`;

        if (params.value.price_range.currency !== 'USD') {
          api += `&currency=${params.value.price_range.currency}`;
        }
      } else {
        searched.value.price = '';
      }
    //}

    ajax.get(api).then((response) => {
      const res = response.data.data;
      let items = page_type.value === 'catalog' ? res.products : res.data;
      // const max_per_page = page_type.value === 'catalog' ? 50 : 20;
      if (!is_search && !is_next) brands.value = page_type.value === 'catalog' ? res.brands : [];
      items.forEach((product) => {
        product.is_tagged = false;
        product.is_checked = false;
      });

      if (!is_next) products.value = [];

      items.forEach((p) => {
        if (page_type.value === 'storefront' && p.product_detail) {
          p.product_detail.in_curation_collection = p.in_curation_collection;
        }

        const product = initProductData(p.product_detail || p);

        if (product.total_color_size_map && product.total_color_size_map.length > 0) {
          product.total_color_size_map.forEach((item) => {
            item.is_selected = false;
            item.is_checked = false;
          });
        }

        product.is_tagged = false;
        products.value.push(product);
      });

      if (res.last_page) {
        is_end.value = res.last_page === page.value;
      } else {
        is_end.value = items.length < res.per_page;
      }
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      is_loading.value = false;
      is_loading_more.value = false;
    });

  }

  const open = (type) => {
    page_type.value = type;
    is_show_drawer.value = true;
    tagged_products.value = [];
    is_review_products.value = false;
    url.value = '';

    if (type !== 'url') {
      getProducts();
    }
  }

  const close = () => {
    is_show_drawer.value = false;
  }

  const hasBrandsStartingWith = (char) => {
    return brands.value.some(brand => {
      const firstChar = (brand.name || '').trim().charAt(0).toUpperCase();
      if (char === 'ALL') return true;
      if (/^\d/.test(char)) {
        return firstChar === char;
      }
      return firstChar === char;
    });
  };

  const filteredBrands = computed(() => {
    let result = brands.value;
    
    if (brandSearchKeyword.value) {
      const keyword = brandSearchKeyword.value.toLowerCase().trim();
      result = result.filter(brand => 
        brand.name.toLowerCase().includes(keyword)
      );
    }
    
    if (selected_letter.value !== 'ALL') {
      result = result.filter(brand => {
        const firstChar = (brand.name || '').trim().charAt(0).toUpperCase();
        if (/^\d/.test(selected_letter.value)) {
          return firstChar === selected_letter.value;
        }
        return firstChar === selected_letter.value;
      });
    }
    
    return result;
  });

  const filterBrandsByLetter = (letter) => {
    selected_letter.value = letter;
  };

  const selectBrands = (is_reset = false) => {
    if (is_reset) {
      selected_brands.value = [];
      brandSearchKeyword.value = '';
      selected_letter.value = 'ALL';
      searched_brands.value = [];
    } else {
      getProducts(false, true);
    }
    
  };

  const showLoading = (is_show) => {
    is_update_data.value = is_show;
  }

  defineExpose({
    open,
    close,
    showLoading
  });

  onMounted(() => {
    event.on('selected-variant-from-url', (obj) => {
      // selected(obj);
      tagged_products.value.push(obj);
    });

    event.on('check-duplicate-variant', (checkData) => {
      // Check for duplicates in tagged_products
      const isDuplicate = tagged_products.value.some(taggedProduct => {
        if (taggedProduct.id !== checkData.id) {
          return false;
        }
        
        // Check if variants match exactly
        if (taggedProduct.total_color_size_map) {
          return taggedProduct.total_color_size_map.some(item => {
            if (!item.is_selected) return false;
            
            const colorMatch = checkData.variant.color ? item.color === checkData.variant.color : !item.color;
            const sizeMatch = checkData.variant.size ? item.size === checkData.variant.size : !item.size;
            
            return colorMatch && sizeMatch;
          });
        }
        
        // If no variant mapping, check if both have no variants selected
        return !checkData.variant.color && !checkData.variant.size;
      });

      // Emit result
      event.emit('duplicate-check-result', { isDuplicate });
    });
  });
</script>
  
<style lang="scss">
  .tag-product-drawer {
    @media screen and (max-width: $mobile_size) {
      width: 100% !important;
    }

    .head {
      display: flex;
      align-items: center;
      padding: 16px;
      background-color: var(--Bg-light);
      position: sticky;
      top: 0;
      z-index: 9;

      i {
        cursor: pointer;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
        color: var(--Text-primary);
        border-radius: var(--radius);
        transition: background-color 0.2s;

        svg {
          width: 16px;
          height: 16px;
        }

        &:hover {
          background-color: var(--Neu-20);
        }
      }

      h2 {
        font: var(--medium-24);
        color: var(--Text-primary);
        flex: 1;
        padding: 0 4px;
      }

      .el-button {
        .t {
          text-transform: capitalize;
          padding-left: 4px;
          padding-right: 4px;
        }
      }

      @media screen and (max-width: $mobile_size) {
        i {
          width: 22px;
          height: 22px;

          svg {
            width: 14px;
            height: 14px;
          }
        }

        h2 {
          font: var(--medium-16);
        }
      }
    }


    .el-drawer__header {
      display: none;
    }

    .el-drawer__body {
      padding: 0;
    }
    
    .content-box {
      padding: 0 16px;

      // &.type-url {
      //   max-width: 800px;
      //   margin: 0 auto;
      // }
    }

    .input-box {
      padding: 8px 0 0;

      .top-col {
        display: flex;
        max-width: 1000px;
        gap: 32px;
        margin: 0 auto;

        & > header {
          // margin: 0 0 24px;
          // padding: 0 0 0 120px;
          position: relative;
          // min-height: 120px;
          // display: flex;
          // flex-direction: column;
          // justify-content: center;

          // .el-image {
          //   width: 120px;
          //   height: 120px;
          //   position: absolute;
          //   top: 0;
          //   left: 0;
          //   border-radius: var(--radius);
          // }

          h2 {
            font: var(--demi-24);
            color: var(--Text-primary);
            margin: 0;
            // padding-left: 24px;
          }

          .link {
            font: var(--medium-14);
            margin: 8px 0 0;
            // padding-left: 24px;

            a {
              display: inline-flex;
              align-items: center;

              svg {
                height: 16px;
                width: 16px;
                margin-left: 4px;
              }
            }
          }

          @media screen and (max-width: $mobile_size) {
            padding: 0 0 0 80px;
            min-height: 80px;

            .el-image {
              width: 80px;
              height: 80px;
            }

            h2 {
              font: var(--demi-22);
            }

            .link {
              font: var(--medium-14);
            }
          }
        }

        .input-url {
          flex: 1;

          & > label {
            font: var(--medium-14);
            color: var(--Text-primary);
            margin: 0 0 8px;
            display: block;
          }

          & > p {
            font-size: 12px;
            color: var(--Text-default);
            margin: 0 0 2px;
            position: relative;
            top: -12px;
          }

          .el-form-item__content {
            flex-wrap: nowrap;

            .el-input {
              flex: 1;
            }

            .el-button {
              --ui-button-bg-color: var(--Black-90);
              --ui-button-border-color: var(--Black-90);
              margin-left: 10px;
            }
          }

        }
      }

    }

    .tip-box {
      background-color: var(--Bg-01);
      padding: 16px;
      max-width: 1000px;
      margin: 0 auto 16px;

      p {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font: var(--medium-14);
        color: var(--Text-secondary);

        svg {
          width: 32px;
          height: 32px;
          margin-right: 10px;
          color: var(--Text-primary);
        }
      }

      img {
        display: block;
        // max-width: 1200px;
        max-height: calc(100vh - 230px);
        max-width: 100%;
        margin: 0 auto;
      }
    }

    .review-products-wrap {
      padding: 16px;
      background-color: var(--Bg-01);

      & > header {
        display: flex;
        align-items: center;
        margin: 0 0 16px;

        h2 {
          font: var(--demi-20);
          color: var(--Text-primary);
          margin: 0;
          flex: 1;
        }
      }
    }



    // .tagged-product-list {
    //   background-color: var(--Bg-01);
    //   padding: 16px;
    //   min-height: 300px;
    //   position: relative;

    //   & > h2 {
    //     font: var(--medium-20);
    //     color: var(--Text-primary);
    //     margin: 0 0 16px;
    //   }

    //   & > div {
    //     display: grid;
    //     grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
    //     gap: 8px;

    //     @media screen and (max-width: $mobile_size) {
    //       grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    //     }

    //     @media screen and (max-width: 400px) {
    //       grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    //     }
    //   }
    // }

    .list-box {
      padding: 16px;

      // .list-title {
      //   font: var(--medium-20);
      //   color: var(--Text-primary);
      //   margin: 16px 0 6px;
      // }

      .load-more {
        padding: 32px 0;
        text-align: center;
        height: 100px;

        .el-button {
          padding-left: 24px;
          padding-right: 24px;
        }
      }

      .no-product {
        padding: 32px 0;
        text-align: center;
        height: 100px;
        
        & > p {
          color: var(--Text-default);
        }

        & > div {
          display: grid;
          justify-content: center;
          svg {
            height: 48px;
            height: 48px;
            fill: var(--Text-default);
            margin: auto;
          }

          h3 {
            font: var(--medium-18);
            color: var(--Text-secondary);
            margin: 10px 0;
          }

          p {
            color: var(--Text-secondary);
          }
        }
      }
      
      .info-head {
        .info {
          display: flex;
          align-items: center;
          margin: 0 0 16px;

          .el-image {
            width: 120px;
            height: 120px;
            border-radius: var(--radius);
            margin-right: 16px;
            // border: 1px solid var(--Border-default);
          }

          h2 {
            font: var(--demi-30);
            color: var(--Text-primary);
            flex: 1;
          }
        }
        
        .filter-wrap {
          display: flex;
          align-items: center;
          gap: 12px;

          .el-input {
            flex: 1;

            svg {
              height: 20px;
              width: 20px;
            }
          }

          .el-button {
            font: var(--medium-14);
            margin: 0;

            svg {
              height: 12px;
              width: 12px;
              margin-right: 8px;

            }
          }

          @media screen and (max-width: $mobile_size) {
            &.has-brands {
              flex-wrap: wrap;

              .el-input {
                width: 100%;
                flex: unset;
              }

              .el-button {
                width: calc(50% - 6px);
              }
            }

          }
        }

        .tags {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 0;

          .el-tag {
            padding: 5px 10px;
            font: var(--medium-12);
            color: var(--Text-secondary);
            background-color: var(--Neu-20);
            cursor: pointer;
            transition: all .2s ease;

            &:hover {
              background-color: var(--Neu-30);
              color: var(--Text-primary);
            }
          }
        }


      }


      .product-list {
        padding-top: 16px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
        gap: 8px;
        position: relative;
        min-height: 300px; 

        @media screen and (max-width: $mobile_size) {
          grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
        }
      }
    }
  }

  .tag-filter-dialog {

    .filter-box {
      & > div {
        margin: 0 0 16px 0;
      }

      h3 {
        font: var(--medium-14);
        color: var(--Text-primary);
        margin: 0 0 8px;
      }

      .el-radio-group {
        display: flex;
      }

      .inputs {
        display: flex;
        align-items: center;
        gap: 8px;
        

        .el-select {
          flex: 1;
          width: auto !important;
          min-width: 80px;
        }

        .el-input-number {
          width: 108px !important;
        }

      }


    }

    .btn-box {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 24px;

      .el-button--primary {
        flex: 1;
      }
    }
  }

  .brands-box {
    padding: 16px 0;
    margin: 0 -16px;
    background-color: var(--Bg-01);

    .search-box {
      padding: 0 16px 16px;
      
      .el-input {
        width: 100%;
        
        svg {
          width: 16px;
          height: 16px;
          color: var(--Text-secondary);
        }
      }
    }

    .filter-letters {
      padding: 0 16px 0;
      display: flex;
      gap: 8px;
      margin-bottom: 16px;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */

      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
      }

      .el-button {
        height: 26px;
        min-width: 26px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font: var(--medium-12);
        flex-shrink: 0;
        margin: 0;

        &:first-child {
          min-width: unset;
          padding: 0 10px;
        }
        
        &.active {
          color: var(--Black-00);
          background-color: var(--Text-brand);
          border-color: var(--Text-brand);
        }
      }
    }

    .brands-list {
      max-height: 400px;
      overflow-y: auto;

      .el-checkbox {
        display: flex;
        padding: 0 16px;
        width: 100%;
        margin-right: 0;
        height: 40px;
        align-items: center;
        cursor: pointer;

        &:hover {
          background-color: var(--Bg-02);
        }

        .brand-item {
          display: flex;
          align-items: center;
          gap: 8px;

          span {
            font: var(--medium-14);
            color: var(--Text-primary);
          }
        }
      }
    }
  }

  .tag-product-click-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 10%;
    bottom: 0;
    z-index: 9999;
    cursor: pointer;

    @media screen and (max-width: $mobile_size) {
      display: none !important;
    }
  }
  </style>